import React from 'react';
import { Route } from 'react-router-dom';
import EbookProvider from './context/EbookProvider';
import AlfaTeoriaPratica from './AlfaTeoriaPratica';
import DynamicHeader from 'components/dynamic_header/DynamicHeader';
import PlanoAnual2025 from './PlanoAnual2025';

const EbooksRoute = () => {
    return (
        <EbookProvider>
            <DynamicHeader />

            <Route exact path={'/ebooks/alfabetizacao-integral-da-teoria-a-pratica-az'} component={AlfaTeoriaPratica} />
            <Route exact path={'/ebooks/plano-anual-instituto-ayrton-senna-2025'} component={PlanoAnual2025} />
        </EbookProvider>
    );
};

export default EbooksRoute;
